import type { PlayerRace } from '@kaeliux/shared';
import humanCharacter from '../assets/images/humans/character_transparent.webp';
import robotCharacter from '../assets/images/robots/character_transparent.webp';
import axonCharacter from '../assets/images/axons/character_transparent.webp';
import humansLogo from '../assets/images/humans/humans_logo.png';
import robotsLogo from '../assets/images/robots/robots_logo.png';
import axonsLogo from '../assets/images/axons/axons_logo.png';

/** Fallback avatar shown when a player has no uploaded profile photo. */
export const RACE_PORTRAITS: Record<PlayerRace, string> = {
    humans: humanCharacter,
    robots: robotCharacter,
    axons: axonCharacter,
};

/** Race emblem used in place of a player's name on the ranking board. */
export const RACE_LOGOS: Record<PlayerRace, string> = {
    humans: humansLogo,
    robots: robotsLogo,
    axons: axonsLogo,
};

/** Capitalized display label for a race, e.g. `'humans'` -> `'Humans'`. */
export function raceLabel(race: PlayerRace | string | undefined): string {
    if (!race) return '—';
    return race.charAt(0).toUpperCase() + race.slice(1);
}
